import { createApi } from '@reduxjs/toolkit/query/react'
import { Methods, NewResponse } from 'types/request.ts'
import { baseQueryWithReauth } from './utils.ts'
import { GetKpiMetricsResponseBody, GetEventsResponseBody, GetEventsQueryStringParameters } from '@boltenergy-be/shared'
import { GetKpiMetricsQueryResponse } from 'store/queries/bolt-backend/types.ts'
import dayjs from 'dayjs'

export const boltBackend = createApi({
  reducerPath: 'boltBackend',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    // ============================
    // QUERIES
    // ============================

    // GET KPI METRICS
    getKpiMetrics: builder.query<GetKpiMetricsQueryResponse, void>({
      query: () => ({
        method: Methods.GET,
        url: '/resources/metrics/kpi'
      }),
      transformResponse: ({ success, data }: NewResponse<GetKpiMetricsResponseBody>) => {
        return {
          metrics: success && data ? data : undefined,
          syncTimestamp: dayjs().toISOString()
        }
      }
    }),

    getEvents: builder.query<GetEventsResponseBody, GetEventsQueryStringParameters>({
      query: (queryStringParameters) => ({
        method: Methods.GET,
        url: '/resources/events',
        params: {
          eventLogType: queryStringParameters.eventLogType,
          from: queryStringParameters.from,
          to: queryStringParameters.to,
          limit: queryStringParameters.limit || 50,
          offset: queryStringParameters.offset || 0,
          authModel: queryStringParameters.authModel
        }
      }),
      transformResponse: ({ success, data }: NewResponse<GetEventsResponseBody>) => {
        return success && data ? data : { events: [], total: 0 }
      }
    })
  })
})

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const {
  // Queries
  useGetKpiMetricsQuery,
  useGetEventsQuery
} = boltBackend
